<template>
  <div class="clear">
    <transition appear @before-enter="beforeEnterBox" @enter="enterBox">
      <h2 data-index="1" class="flex flex-row">
        Web Projects <small>({{ projects.length }} repo)</small>
      </h2>
    </transition>
    <transition-group
      appear
      tag="div"
      class="grid grid-3"
      @before-enter="beforeEnter"
      @enter="enter"
    >
      <Project
        v-for="(project, index) in toggleText ? projects.slice(0, 6) : projects"
        :key="project.id"
        :project="project"
        :langs="[
          project.name.includes('React')
            ? 'react'
            : project.name.includes('Vue')
            ? 'vuejs'
            : '',
          'html5',
          'css3',
          'js',
        ]"
        :data-index="index"
      />
    </transition-group>
    <ReadMoreButton
      class="show-all"
      v-if="projects.length > 6"
      :toggleText="toggleText"
      @readMore="handleButton($event)"
    />
  </div>
</template>
<script>
import Project from "./Project";
import { ReadMoreButton } from "../../components";
import { ref } from "vue";
export default {
  components: { Project, ReadMoreButton },
  props: {
    projects: Array,
    beforeEnter: Function,
    enter: Function,
    beforeEnterBox: Function,
    enterBox: Function,
  },
  setup() {
    const toggleText = ref(true);
    const handleButton = (val) => (toggleText.value = val);
    return { toggleText, handleButton };
  },
};
</script>
<style scoped>
#projects h2 {
  background: var(--grey);
  color: var(--light);
}
</style>
